// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lt-table-move-dialog__unassigned {
  margin-top: 10px;
  padding: 0 12px 8px;
  flex-shrink: 0;
}

.lt-table-move-dialog__unassigned h3 {
  margin: 0 0 8px;
  font-size: 0.85rem;
  font-weight: 700;
  color: rgba(248, 250, 252, 0.88);
}

.lt-table-move-dialog__unassigned ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 6px;
}

.lt-table-move-dialog__unassigned-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.06);
  color: #f8fafc;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  text-align: left;
}

.lt-table-move-dialog__unassigned-btn:hover:not(:disabled) {
  background: rgba(8, 119, 188, 0.22);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 45%, #fff);
}

.lt-table-move-dialog__unassigned-btn--selected {
  background: rgba(8, 119, 188, 0.3);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 70%, #fff);
  box-shadow: 0 0 0 2px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);
}

.lt-table-move-dialog__unassigned-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.lt-table-move-dialog__other-station-hint {
  margin: -2px 0 8px;
  font-size: 0.75rem;
  font-weight: 500;
  color: rgba(248, 250, 252, 0.62);
}

.lt-table-move-dialog__other-station-name {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.lt-table-move-dialog__station-chip {
  flex-shrink: 0;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 35%, transparent);
  border: 1px solid
    color-mix(in srgb, var(--lt-brand-secondary, #46528b) 55%, transparent);
  color: #fde68a;
}

.light-mode .lt-table-move-dialog__other-station-hint {
  color: #64748b;
}

.light-mode .lt-table-move-dialog__station-chip {
  background: color-mix(in srgb, #f59e0b 16%, #fff);
  border-color: color-mix(in srgb, #f59e0b 40%, #cbd5e1);
  color: #92400e;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/LiveTrainingTableMoveDialog.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,oEAAoE;AACtE;;AAEA;EACE,kCAAkC;EAClC,oEAAoE;EACpE,uEAAuE;AACzE;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mFAAmF;EACnF;2EACyE;EACzE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iDAAiD;EACjD,sDAAsD;EACtD,cAAc;AAChB","sourcesContent":[".lt-table-move-dialog__unassigned {\n  margin-top: 10px;\n  padding: 0 12px 8px;\n  flex-shrink: 0;\n}\n\n.lt-table-move-dialog__unassigned h3 {\n  margin: 0 0 8px;\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: rgba(248, 250, 252, 0.88);\n}\n\n.lt-table-move-dialog__unassigned ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 6px;\n}\n\n.lt-table-move-dialog__unassigned-btn {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  background: rgba(255, 255, 255, 0.06);\n  color: #f8fafc;\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  text-align: left;\n}\n\n.lt-table-move-dialog__unassigned-btn:hover:not(:disabled) {\n  background: rgba(8, 119, 188, 0.22);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 45%, #fff);\n}\n\n.lt-table-move-dialog__unassigned-btn--selected {\n  background: rgba(8, 119, 188, 0.3);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 70%, #fff);\n  box-shadow: 0 0 0 2px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);\n}\n\n.lt-table-move-dialog__unassigned-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.lt-table-move-dialog__other-station-hint {\n  margin: -2px 0 8px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: rgba(248, 250, 252, 0.62);\n}\n\n.lt-table-move-dialog__other-station-name {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.lt-table-move-dialog__station-chip {\n  flex-shrink: 0;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 0.65rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 35%, transparent);\n  border: 1px solid\n    color-mix(in srgb, var(--lt-brand-secondary, #46528b) 55%, transparent);\n  color: #fde68a;\n}\n\n.light-mode .lt-table-move-dialog__other-station-hint {\n  color: #64748b;\n}\n\n.light-mode .lt-table-move-dialog__station-chip {\n  background: color-mix(in srgb, #f59e0b 16%, #fff);\n  border-color: color-mix(in srgb, #f59e0b 40%, #cbd5e1);\n  color: #92400e;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
